import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export default {
  description: function description(state) {
    return state.description;
  },
  products: function products(state) {
    return state.products;
  },
  productsCount: function productsCount(state) {
    return state.total;
  }
};